app.controller('evidenceManagementController', async function ($rootScope, $scope, $filter, safeApply, evidenceManagementService, systemService) {

  const currentYear = new Date().getFullYear();

  $scope.currentCountyName = 'Dallas'  //'collin'
  $scope.currentCountyCadCode = '057' //'043'

  $scope.tax_year = currentYear
  $scope.closed = true
  $scope.reportComplete = 0
  $scope.loading = true
  $scope.reviewed = false
  $scope.showUncheckedPhotos = true
  $scope.showUncheckedRepairs = true
  $scope.showHaveOffer = 0
  $scope.showCreateReportOnly = -1
  $scope.selectedIndex = -1
  $scope.showQualityRating = 0
  $scope.showingPID = false
  $scope.pid = ""
  $scope.years = Array.from({ length: currentYear - 2024 + 1 }, (_, i) => 2024 + i);
  $scope.dataSaved = true
  $scope.current_tab = 0
  $scope.activeFolder = 0

  $scope.threeDayOldSubmissionsOnly = true

  $scope.updateAppealResearch = async function (value) {
    // create a new record 
    if ($scope.item.research_method_id == null) {
      $scope.item.research_method_id = value
      const obj = {
        appeal_id: $scope.item.appeal_id,
        research_method_id: value
      }
      console.log('obj :>> ', obj)
      let countyListResults = await systemService.functionCall({ type: "createAppealResearchRecord", fields: obj })
    } else {
      // update existing record
      const obj = {
        appeal_id: $scope.item.appeal_id,
        research_method_id: value
      }
      console.log('obj :>> ', obj)
      let countyListResults = await systemService.functionCall({ type: "updateAppealResearchRecord", fields: obj })
    }
    safeApply($scope)
  }

  $scope.searchQualityRating = (value) => {
    $scope.showQualityRating = value
    $scope.getAllEvidence()
  }

  $scope.getAllEvidence = async function () {
    $scope.data = null
    $scope.loading = true
    safeApply($scope)
    const obj = {
      cad_code: $scope.currentCountyCadCode,
      tax_year: $scope.tax_year,
      cad_report_created: $scope.reportComplete,
      reviewed: $scope.reviewed ? 1 : 0,
      closed: $scope.closed ? 1 : 0,
      quality: $scope.quality,
      qualityRating: $scope.showQualityRating,
      pid: $scope.pid || '',
      threeDayOldSubmissionsOnly: $scope.threeDayOldSubmissionsOnly ? 1 : 0
    }
    console.log('obj :>> ', obj);
    const data = await evidenceManagementService.getAllEvidence(obj)
    $scope.data = data.data.data
    if ($scope.data.length > 0 && $scope.showingPID == true) {
      $scope.setActiveItem(0)
      $scope.showQualityRating = $scope.data[0].quality
      $scope.currentCountyCadCode = $scope.data[0].cad_code
      $scope.currentCountyName = $scope.data[0].county
    }
    console.log('data :>> ', data);
    $scope.loading = false;
    safeApply($scope)
  }

  $scope.requeryForOlderSubmissions = () => {
    $scope.threeDayOldSubmissionsOnly = !$scope.threeDayOldSubmissionsOnly
    $scope.newSelectedItem = null
    $scope.selectedIndex = -1
    $scope.getAllEvidence()
  }

  // $scope.filterRecentUpdates = function (d) {
  //   // If filter is disabled, show all items
  //   if (!$scope.threeDayOldSubmissionsOnly) {
  //     return true;
  //   }

  //   // Current date
  //   var now = new Date();
  //   // 3 days in milliseconds
  //   var threeDaysInMs = 3 * 24 * 60 * 60 * 1000;

  //   // Check if all three update fields exist and are more than 3 days old
  //   var documentsOld = !d.lastupdate_documents || (now.getTime() - new Date(d.lastupdate_documents).getTime() > threeDaysInMs);
  //   var photosOld = !d.lastupdate_photos || (now.getTime() - new Date(d.lastupdate_photos).getTime() > threeDaysInMs);
  //   var notesOld = !d.lastupdate_user_notes || (now.getTime() - new Date(d.lastupdate_user_notes).getTime() > threeDaysInMs);

  //   // Show the item only if all three fields are more than 3 days old or don't exist
  //   return documentsOld && photosOld && notesOld;
  // };

  $scope.setActiveItem = async (index) => {
    if ($scope.dataSaved == false) {
      $scope.showSaveChangesModal()
      $scope.newSelectedItem = index
      return
    }
    const EPID = $scope.data[index].evidence_portal_id
    $scope.newSelectedItem = null
    $scope.selectedIndex = index
    $scope.loading = true
    safeApply($scope)
    const obj = {
      cad_code: $scope.currentCountyCadCode,
      tax_year: $scope.tax_year,
      epid: EPID
    }
    console.log('obj :>> ', obj);
    const data = await evidenceManagementService.getEvidenceRecord(obj)
    console.log('data :>> ', data.data.data);
    if (data.data.data.length > 0) {
      $scope.item = data.data.data[0]
    } else {
      $scope.item = null
    }
    console.log('$scope.item :>> ', $scope.item)
    $scope.loading = false
    safeApply($scope)
  }

  $scope.openEmailModal = () => {
    const fromEmails = {
      'TPTC': { email: 'info@texasptc.com', name: 'Texas PTC' },
      'default': { email: 'support@goodrichrc.com', name: 'PropertyTAX.io' }
    }
    const _FROM = fromEmails[$scope.item.business_source] || fromEmails.default
    const _TO = { email: $scope.item.username, name: `${$scope.item.first_name} ${$scope.item.last_name}` }

    $scope.email_data = {
      to: _TO,
      from: _FROM,
      subject: ``,
      body: `Hello ${$scope.item.first_name}, \n\n\n\n` +
        'Property:\n' +
        `Tax ID: ${$scope.item.cad_account}\n` +
        `Address: ${$scope.item.address}\n\n` +
        `Direct Link to your Evidence Portal:\n` +
        `<a href="https://evidence.propertytax.io/${$scope.item.user_id}/${$scope.item.user_token}/${$scope.item.prop_id}">https://evidence.propertytax.io/${$scope.item.user_id}/${$scope.item.user_token}/${$scope.item.prop_id}</a>\n\n` +
        'Direct Link to your Dashboard:\n' +
        `<a href="https://dashboard.propertytax.io/${$scope.item.user_id}/${$scope.item.user_token}">https://dashboard.propertytax.io/${$scope.item.user_id}/${$scope.item.user_token}</a>\n\n\n` +

        `Thank you!\n\nGoodrich Realty Consulting, LLC\n`
    }
    // $scope.email_data.to.email = "bryanutley2000@yahoo.com"
    safeApply($scope)
  }
  $scope.sendEmail = async () => {
    let sendEmailResults = await systemService.functionCall({ type: "sendStandardEmail", data: $scope.email_data })
    if (sendEmailResults.data.success) {
      toastr.success("Email was sent successfully!", "Client Email", { timeOut: 8000 })
    } else {
      toastr.error("Email was NOT successful!", "Client Email", { timeOut: 10000 })
    }
  }

  $scope.getDocumentCount = () => {
    if (!$scope.item) return
    const i = $scope.item.documents
    const targetTipNames = ["purchase_documents", "other_documents", "appraisal_documents"]
    return i.reduce((total, obj) => {
      if (targetTipNames.includes(obj.tip_name)) {
        return total + (obj.files ? obj.files.length : 0)
      }
      return total
    }, 0)
  }

  $scope.getCommentsAvailable = () => {
    if (!$scope.item) return
    if ($scope.item.user_notes) {
      return $scope.item.user_notes.length > 0 ? "YES" : "NO"
    }
    return "NO"
  }

  $scope.getPhotoEstimateCounts = () => {
    if (!$scope.item) return
    if (!$scope.item.photos) return '( NO )'
    const i = $scope.item.photos
    let photoCount = 0
    let estimateCount = 0
    if (i) {
      for (let j = 0; j < i.length; j++) {
        const item = i[j].files
        photoCount += item.photos.length
        estimateCount += item.estimates.length
      }
      return `( ${photoCount} | ${estimateCount} )`
    }
  }

  $scope.viewPDF = (pdfUrl) => {
    window.open(pdfUrl, '_blank')
  }

  $scope.viewReport = (rptType) => {
    let url
    if ($scope.item.business_source == "TPTC") {
      url = `https://evidence.texasptc.com/report_preview/${$scope.item.user_id}/${$scope.item.user_token}/${$scope.item.prop_id}/${rptType}`
    } else {
      url = `https://evidence.texasptc.com/report_preview/${$scope.item.user_id}/${$scope.item.user_token}/${$scope.item.prop_id}/${rptType}`
    }
    if (url) {
      window.open(url, '_blank')
    } else {
      toastr.error('URL NOT Found')
    }
  }

  $scope.openEvidencePortal = () => {
    let url
    if ($scope.item.business_source == "TPTC") {
      url = `https://evidence.texasptc.com/${$scope.item.user_id}/${$scope.item.user_token}/${$scope.item.prop_id}`
    } else {
      url = `https://evidence.propertytax.io/${$scope.item.user_id}/${$scope.item.user_token}/${$scope.item.prop_id}`
    }
    if (url) {
      window.open(url, '_blank')
    } else {
      toastr.error('URL NOT Found')
    }
  }

  $scope.capitalizeFirstLetter = (str) => {
    return str
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ')
  }

  $scope.replaceHTMLTags = (str) => {
    return str.replace(/<[^>]*>?/gm, ' ')
  }

  $scope.setPortalType = (closed) => {
    $scope.closed = closed
    $scope.selectedIndex = -1
    $scope.getAllEvidence()
  }

  $scope.setReportComplete = (reportComplete) => {
    $scope.reportComplete = reportComplete
    $scope.getAllEvidence()
  }

  $scope.setReviewed = (reviewed) => {
    $scope.reviewed = reviewed
    $scope.getAllEvidence()
  }

  $scope.setActiveFolder = (index) => {
    $scope.activeFolder = index
  }

  $scope.setShowCreateReportOnly = (createReport) => {
    $scope.showCreateReportOnly = createReport
    $scope.selectedIndex = -1
    $scope.getAllEvidence()
  }

  $scope.setHaveOffer = (showHaveOffer) => {
    $scope.showHaveOffer = showHaveOffer
    $scope.selectedIndex = -1
    $scope.getAllEvidence()
  }

  $scope.findPID = () => {
    if ($scope.showingPID) {
      $scope.showingPID = false
      $scope.pid = ""
      $scope.showQualityRating = 0
      $scope.getAllEvidence()
      $scope.threeDayOldSubmissionsOnly = false
      safeApply($scope)
      return
    } else {
      $scope.showingPID = true
    }
    $scope.selectedIndex = 0
    $scope.threeDayOldSubmissionsOnly = false
    $scope.getAllEvidence()
  }

  $scope.setCounty = (county) => {
    console.log('county :>> ', county);
    if (!county) return
    $scope.currentCountyName = county.county
    $scope.currentCountyCadCode = county.cad_code

    console.log('$scope.currentCountyName :>> ', $scope.currentCountyName);
    console.log('$scope.currentCountyCadCode :>> ', $scope.currentCountyCadCode);

    $scope.getAllEvidence()
    safeApply($scope)
  }

  $scope.changeTab = (tab) => {
    $scope.current_tab = tab
  }

  $scope.refreshQuery = () => {
    $scope.selectedIndex = -1
    $scope.getAllEvidence()
  }

  $scope.saveItem = async () => {
    const item = $scope.item

    // Set all to reviewed = true
    if (item.photos) {
      item.photos.forEach(photoItem => {
        if (photoItem.files?.photos) {
          photoItem.files.photos.forEach(p => {
            p.reviewed = true
          })
        }
        if (photoItem.files?.estimates) {
          photoItem.files.estimates.forEach(e => {
            e.reviewed = true
          })
        }
      })
    }
    if (item.documents) {
      item.documents.forEach(docItem => {
        if (docItem.files) {
          docItem.files.forEach(d => {
            d.reviewed = true
          })
        }
      })
    }

    const obj = {
      evidence_portal_id: item.evidence_portal_id,
      user_notes_show_on_report: item.user_notes_show_on_report,
      photos: item.photos,
      documents: item.documents,
      review_notes: item.review_notes,
      reviewed_by: item.reviewed_by,
      reviewed_on: item.reviewed_on,
      quality: item.quality,
    }
    console.log('obj :>> ', obj)

    const saveEvidenceRecordResults = await evidenceManagementService.saveEvidenceRecord(obj)
    if (saveEvidenceRecordResults.data.success) {
      toastr.success('Data Saved')
    } else {
      toastr.error('Error Saving Data')
    }

    $scope.closeSaveChangesModal()
    $scope.dataSaved = true
    if ($scope.newSelectedItem != null) {
      $scope.setActiveItem($scope.newSelectedItem)
    }
    safeApply($scope)
  }

  $scope.updateCreateReport = (value) => {
    console.log("Set to " + value);
    const p = $scope.item
    p.create_report = value
    if (p.create_report == 1) {
      p.create_report_by = $rootScope.user_info.initials
    } else {
      p.create_report_by = ''
    }
    $scope.dataSaved = false
    safeApply($scope)
  }

  $scope.updateQualityRating = (value) => {
    const p = $scope.item
    p.quality = value
    p.reviewed_by = $rootScope.user_info.initials
    p.reviewed_on = new Date()
    switch (value) {
      case -1:
      case 1:
      case 2:
      case 3:
        p.reviewed_by = $rootScope.user_info.initials
        p.reviewed_on = new Date()
        break
      case 0:
        p.reviewed_by = ''
        p.reviewed_on = null
    }
    $scope.dataSaved = false
    safeApply($scope)
  }

  $scope.showFullsizeImage = (url, description) => {
    const modalID = '#largePhotoModal'
    $scope.fullsizeImage = url
    $scope.fullsizeImageDescription = description
    $(modalID).modal('show')
    safeApply($scope)
    $scope.closeFullsizeImage = () => {
      $(modalID).modal('hide')
    }
  }

  $scope.showSaveChangesModal = () => {
    const modalID = '#saveChangesModal'
    $(modalID).modal('show')
    safeApply($scope)
  }
  $scope.closeSaveChangesModal = () => {
    const modalID = '#saveChangesModal'
    $(modalID).modal('hide')
  }

  $scope.showAddNotesModal = () => {
    console.log('item :>> ', $scope.item);
    const modalID = '#addNotesModal'
    $(modalID).modal('show')
    $(modalID).on('shown.bs.modal', function (event) {
      document.getElementById("notes").focus();
    })
    $scope.dataSaved = false
    safeApply($scope)

    $scope.closeAddNotesModal = () => {
      $(modalID).modal('hide')
    }
  }

  $scope.setShowInReport = (p) => {
    p.use_on_report = !p.use_on_report
    $scope.dataSaved = false
    safeApply($scope)
    console.log('$scope.item :>> ', $scope.item);
  }

  $scope.setShowUserNotesInReport = (p) => {
    p.user_notes_show_on_report = !p.user_notes_show_on_report
    $scope.dataSaved = false
    safeApply($scope)
  }

  $scope.setShowPDFInReport = (d) => {
    d.use_on_report = !d.use_on_report
    $scope.dataSaved = false
    safeApply($scope)
    console.log('$scope.item :>> ', $scope.item);
  }

  $scope.updateImportant = () => {
    const p = $scope.item
    p.important = !p.important
    $scope.dataSaved = false
    safeApply($scope)
  }

  $scope.setDataUnsaved = () => {
    $scope.dataSaved = false
  }

  init()
  async function init() {
    let countyListResults = await systemService.functionCall({ type: "getEvidencePortalCountyList", active_only: true })
    if (countyListResults.data.success) {
      $scope.countyList = countyListResults.data.data
      console.log('$scope.countyList :>> ', $scope.countyList);
    } else {
      console.log("*** System Error (countyListResults) ***")
    }

    let appealResearchResults = await systemService.functionCall({ type: "getAppealResearchMethods", active_only: true })
    console.log('appealResearchResults :>> ', appealResearchResults);
    if (appealResearchResults.data.success) {
      $scope.appealResearchOptions = appealResearchResults.data.data
      console.log('$scope.appealResearchOptions :>> ', $scope.appealResearchOptions);
    } else {
      console.log("*** System Error (appealResearchOptions) ***")
    }

    $scope.getAllEvidence()
  }


  // Filters |---------------------------------------------------
  $scope.photoLocationFilter = (item) => {
    if (!item.photos) return false
    return item.photos.length > 0
  }

  // $scope.photoFilter = (item) => {
  //   if (item) {
  //     return (item.use_in_report) || ($scope.showUncheckedPhotos == true ? 0 : 1) == item.use_in_report
  //   } else {
  //     return false
  //   }
  // }

  // $scope.repairFilter = (item) => {
  //   return (item.use_in_report == true) || $scope.showUncheckedRepairs !== item.use_in_report

  // }

})